import React from 'react';

import { ManageOrders } from 'features/orders';

export const AdminPayinOrdersPage: React.FC = () => <ManageOrders />;
